<template>
	<div class="more">
		<back-to :url="packageTour" :query="type"></back-to>
		<section class="more_content" v-if="type < 3">
			<van-sidebar v-model="activeKey" class="more_content-left" @change="change">
				<van-sidebar-item v-for="(item, index) in desCurren"  :key="index" :title="item.Name" />
			</van-sidebar>
			<div class="more_content-right">
				<span class="more_content-right_title">推荐</span>
				<div class="more_content-right_list">
					<ul>
						<li v-for="(item, index) in desCurrenCity.City"  :key="index"
							@click="$router.push({path: '/packageSearch',query:{disArr:desCurrenCity,type:type,disArrIndex:index}})">
							<img v-lazy="item.Url" />
							<p>{{item.Name}}</p>
						</li>
					</ul>
				</div>
			</div>
		</section>
		<section class="more_content" v-if="type == 3">
			<van-sidebar v-model="activeKey" class="more_content-left" @change="change">
				<van-sidebar-item v-for="(item, index) in desCurren"  :key="index" :title="item.name" />
			</van-sidebar>
			<div class="more_content-right">
				<span class="more_content-right_title">推荐</span>
				<div class="more_content-right_list">
					<ul>
						<li v-for="(item, index) in desCurrenCity.newResponsePlace_Cities"  :key="index"
							@click="$router.push({path: '/customSwim',query:{jqId:item.jqId,tagId:item.tagId}})">
							<img v-lazy="item.imageUrl" />
							<p>{{item.name}}</p>
						</li>
					</ul>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
	import BackTo from "@/components/BackTo";
	export default {
		name: 'more',
		components: {
			BackTo
		},
		data() {
			return {
				packageTour: '/packageTour',
				activeKey: 0,
				type: 1,
				desCurren: [],
				desCurrenCity: []
			}
		},
		created() {
			this.type = this.$route.query.type
		},
		mounted() {
			if(this.type == 3){
				this.connectCityList()
			}else{
				this.getPath()
			}
		},
		methods: {
			change(e) {
				this.activeKey = e
				this.desCurrenCity = this.desCurren[e]
			},
			getPath() {
				var data = {
					State: this.type == 1 ? 0 : 1, // 0国内 1国外
					Count: 0 // 多少条
				}
				this.$post(
					this.$apiWebsiteSweet + '/api/GetGTLine', data
				).then(res => {
					if (this.type == 1) {
						this.desCurren = res.GN
						this.desCurrenCity = res.GN[0]
					} else {
						this.desCurren = res.GW
						this.desCurrenCity = res.GW[0]
					}
				})
			},
			connectCityList() {
				var data = {}
				this.$post(
					this.$connectHttpSweet + '/NewNearTravel/DBDZNearTravelPlace', data
				).then(res => {
					this.desCurren = res.result.splice(0, 3)
					this.desCurrenCity = this.desCurren[0]
					this.packageTour = "/customSwim"
				})
			}
		}
	}
</script>

<style>
	.more_content {
		width: 100%;
		display: flex;
	}

	.more_content-left {
		height: calc(100vh - 88px);
		overflow-y: auto;
		background-color: #f7f8fa
	}

	.more_content-left .van-sidebar-item {
		line-height: 80px;
		padding-top: 0;
		padding-bottom: 0;
		text-align: center;
	}

	.more_content-left .van-sidebar-item--select::before {
		background-color: #ff8a00;
	}

	.more_content-right_list {
		width: 100%;
	}

	.more_content-right {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0 30px;
		box-sizing: border-box;
		height: calc(100vh - 88px);
		overflow-y: auto;
	}

	.more_content-right_title {
		height: 84px;
		font-size: 28px;
		color: #333;
		line-height: 84px;
	}

	.more_content-right_list img {
		width: 240px;
		height: 160px;
		border-radius: 10px;
	}

	.more_content-right_list ul {
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.more_content-right_list li {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		margin-bottom: 40px;
	}

	.more_content-right_list li p {
		margin-top: 20px;
		font-size: 28px;
		color: #888;
	}
</style>
